import {ArrowUpRightIcon, ChevronRightIcon, type Icon} from '@primer/octicons-react'
import {clsx} from 'clsx'

import {getAnalyticsEvent} from '@github-ui/swp-core/lib/utils/analytics'

import {useUrlContext} from '../../contexts/UrlContext'

import styles from '../../MarketingNavigation.module.css'

export type NavLinkType = {
  className?: string
  context?: string
  external?: boolean
  icon?: Icon
  image?: {light: string; dark: string}
  render?: boolean
  subtitle?: string
  title: string
  url: string
  withArrow?: boolean
}

export function NavLink(props: NavLinkType) {
  const {shouldUseDotcomLinks} = useUrlContext()

  const {
    className,
    context,
    external = false,
    icon: IconComponent,
    render = true,
    subtitle,
    title,
    url,
    withArrow = false,
    image,
  } = props

  if (render === false) {
    return null
  }

  const resolvedUrl = shouldUseDotcomLinks && url.startsWith('/') ? `https://github.com${url}` : url

  const analyticsAttrs = {
    ...getAnalyticsEvent({
      action: title,
      tag: 'link',
      context: context || '',
      location: 'navbar',
    }),
  }

  if (className) {
    return (
      <a href={resolvedUrl} {...analyticsAttrs} className={className}>
        {title}
      </a>
    )
  }

  return (
    <a
      href={resolvedUrl}
      {...analyticsAttrs}
      target={external ? '_blank' : undefined}
      rel={external ? 'noreferrer' : undefined}
      className={clsx(styles.Link, image && styles.Card)}
    >
      {image ? (
        <span className={styles.Thumbnail} aria-hidden="true">
          <img src={image.light} alt="" width={240} height={150} className={styles.LightImage} />
          <img src={image.dark} alt="" width={240} height={150} className={styles.DarkImage} />
        </span>
      ) : null}

      {IconComponent ? (
        <span className={styles.Icon}>
          <IconComponent size={16} />
        </span>
      ) : null}

      <span className={styles.Copy}>
        <span className={styles.LinkTitle}>
          <span className={styles.LinkText}>{title}</span>
          {external ? <ArrowUpRightIcon size={12} aria-label="(opens in a new tab)" /> : null}
          {withArrow ? <ChevronRightIcon size={16} className={styles.Arrow} /> : null}
        </span>
        {subtitle ? <span className={styles.Subtitle}>{subtitle}</span> : null}
      </span>
    </a>
  )
}
